import * as type from './mutation-types';

export const state = {
    //用户信息
    userInfo: {},
    //菜单项
    menuList: [],
    //应用列表
    appList: [],
    //系统列表
    projectList: [],
    //用户是否已登录
    isLogin: localStorage.getItem('user_login') ? true : false,
    //系统id
    projectId: '',
    //系统类别
    categoryList: [],
    //权限
    businessMenuIdList: [],
}

export const mutations = {
    //获取用户相关信息
    [type.GET_USER_INFO](state,data) {
        //个人信息
        state.userInfo = data.userInfo || {}
        //菜单权限
        state.menuList = data.menuList || []
        //按钮权限
        state.businessMenuIdList = data.businessMenuIdList && data.businessMenuIdList.split(',')
    },
    //用户登录触发
    [type.USER_LOGIN](state,data){
        state.isLogin = data
    },
    //获取系统列表
    [type.GET_PROJECTS](state,data) {
        state.projectList = data.list || []
        state.projectId = data.projectId
    },
    //系统id
    [type.FILTER_PROJECT_ID](state,data) {
        state.projectId = data
    },
    //应用列表
    [type.GET_ALL_APP](state,data) {
        state.appList = data || []
    },
    //系统类别
    [type.GET_ALL_CATEGORY](state,data) {
        state.categoryList = data || []
    }
}